export { default as CourseFaqsDetailPage } from "./container/CourseFaqsDetail";
